/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Statement_Taxonomy_Editor_SaveInputs */

const en_statement_taxonomy_editor_save = /** @type {(inputs: Statement_Taxonomy_Editor_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save draft`)
};

const nl_statement_taxonomy_editor_save = /** @type {(inputs: Statement_Taxonomy_Editor_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Concept opslaan`)
};

/**
* | output |
* | --- |
* | "Save draft" |
*
* @param {Statement_Taxonomy_Editor_SaveInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const statement_taxonomy_editor_save = /** @type {((inputs?: Statement_Taxonomy_Editor_SaveInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statement_Taxonomy_Editor_SaveInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_statement_taxonomy_editor_save(inputs)
	return en_statement_taxonomy_editor_save(inputs)
});